import { render, staticRenderFns } from "./TwoCard.vue?vue&type=template&id=00f180e8"
import script from "./TwoCard.vue?vue&type=script&lang=js"
export * from "./TwoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports